import { PORT, RU_URL } from 'const';
const punycode = require('punycode');

export const getSubdomainUrl = (code: string, isProduction: boolean) =>
  isProduction
    ? `https://${punycode.toASCII(code)}.${RU_URL}/`
    : `http://${punycode.toASCII(code)}.localhost:${PORT}`;
